export class LoginService {
    /* @ngInject */
    constructor($http, egUrlService, $log, $q) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$log = $log;
        this.$q = $q;
    }

    login(credentials) {
        var url = this.egUrlService.url('/authentication/credentials/password/validate');
        return this.$http.post(url, credentials)
            .then(response => {
                return this._requestSuccess(response);
            }, response => {
                return this._requestError(response);
            });
    }

    _requestSuccess(response) {
        this.$log.log(response.data);
        return response.data;
    }

    _requestError(response) {
        this.$log.error('Login attempt failed with the following error: ' + response.statusText);
        return this.$q.reject(response.data);
    }

    isAuthenticated() {
        var url = this.egUrlService.url('/authentication/credentials/password/isAuthenticated');
        return this.$http.get(url)
            .then(LoginService._handleResponse, LoginService._handleResponse);
    }

    hasInstallation() {
        var url = this.egUrlService.url('/authentication/credentials/password/hasInstallation');
        return this.$http.get(url)
            .then(LoginService._handleResponse, LoginService._handleResponse);
    }

    static _handleResponse(response) {
        return response.data;
    }
}
